import type { KambiBetOffer, KambiEvent } from '@mobi/api-types/kambi'
import { simpleFetch } from '@mobi/utils/fetch/simpleFetch'

export const getKambiEventOutcomePricing = ({ eventId, outcomeIds }: EventOutcomePricingParams) => {
  const base = window._kc.apiOfferingBaseUrl
  const query = '?excludeBetOffers=true&lang=en_AU&market=AU'
  return simpleFetch<KambiEventOutcomePricingResponse>(
    `${base}onDemandPricing/event/${eventId}/outcome/${outcomeIds.join(',')}${query}`
  )
}

// =====
// Types
// =====

type KambiEventOutcomePricingResponse = {
  /** The event identifier of the on-demand-pricing bet */
  eventId: number
  /** Outcome identifiers that have been selected and is part of the pricing.
   *  Will be empty when there is no selection */
  selectedOutcomeIds: number[]
  selectedOdds: {
    /** Odds. See general documentation for format */
    decimal: number
    american: string
    fractional: string
  }
  /** Outcome identifiers within this event that might be included in an on-demand combination */
  combinableOutcomeIds: number[]
}

type EventOutcomePricingParams = {
  eventId: KambiEvent['id']
  outcomeIds: KambiBetOffer['outcomes'][0]['id'][]
}
